import { Component } from '@angular/core';

@Component({
    selector: 'dsh-sections',
    template: `<router-outlet></router-outlet>`,
})
export class SectionsComponent {}
